module.exports = __webpack_public_path__ + "img/royal-prince-hostel.c0af48fd.jpg";